import {
  BookOpen,
  CheckSquare,
  CreditCard,
  LayoutDashboard,
  Settings,
  Sliders,
  Sparkles,
  TrendingUp,
  Users,
} from 'lucide-react';
import type { ReactNode } from 'react';

export const GROUP_RAIL_ICONS: Record<string, ReactNode> = {
  'Command Center': <LayoutDashboard className="h-5 w-5" />,
  'Pipeline': <TrendingUp className="h-5 w-5" />,
  'Clients': <Users className="h-5 w-5" />,
  'Work': <CheckSquare className="h-5 w-5" />,
  'Billing': <CreditCard className="h-5 w-5" />,
  'AI Systems': <Sparkles className="h-5 w-5" />,
  'Knowledge': <BookOpen className="h-5 w-5" />,
  'Settings': <Settings className="h-5 w-5" />,
  'Operations': <Sliders className="h-5 w-5" />,
  'Overview': <LayoutDashboard className="h-5 w-5" />,
};
